import { useEffect, useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../Layout.css';
import Ai2Sidebar from './Ai2Sidebar';
import Ai2Navbar from './Ai2Navbar';

function Ai2Layout({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 1024);

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1024) {
                setSidebarOpen(false);
            } else {
                setSidebarOpen(true);
            }
        };

        window.addEventListener('resize', handleResize);

        // Initial check
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSidebar = () => {
        setSidebarOpen(prev => !prev);
    };

    return (
        <>
            <Ai2Navbar />
            <div className="layout">
                <div
                    className={`sidebar-toggle-btn ${sidebarOpen ? 'on-sidebar' : 'on-screen'}`}
                    onClick={toggleSidebar}
                >
                    {sidebarOpen ? <FaTimes className='toggle1' /> : <FaBars />}
                </div>

                <Ai2Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
                <main className={`content ${sidebarOpen ? 'open' : 'collapsed'}`}>
                    {children}
                </main>
            </div>
        </>
    );
}

export default Ai2Layout;
